import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorContentState = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorContentStateEditorContentState" */ '../src/EditorContentState/EditorContentState'
			)
		).EditorContentState,
});
